import { required, minLength, minValue, maxValue } from '@vuelidate/validators';

export default {
  name: {
    required,
    minLength: minLength(3),
  },
  displayName: {},
  description: {},
  autoResolveDuration: {
    minValue: minValue(5),
  },
  responseDelayDuration: {
    minValue: minValue(0),
    maxValue: maxValue(240),
  },
  accessToCurrentDatetime: {},
  accessToPreviousConversations: {},
};
